import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Fade from '@material-ui/core/Fade'
import CardHeader from '@material-ui/core/CardHeader'
import { WID } from '../../../constants/Language'
import Word from '../../../containers/Common/Word'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'

const styles = theme => ({
})

class DonationSettingsCard extends React.Component {

  handleClickSwitch = (event) => {
    this.props.handleClickSwitch()
  }

  handleClickSwitch = (name) => (event) => {
    this.props.handleClickSwitch({ [name]: event.target.checked })
    this.setState({ [name]: event.target.checked })
  }

  render() {
    const { settings } = this.props
    var isVisibleDonor = this.props.settings ? Boolean(this.props.settings.isVisibleDonor) : false

    return (
      <React.Fragment>
        <Fade in={Boolean(settings)}>
          <Card>
            <CardHeader title={<Word wid={WID.DONATION_SETTINGS_CARD.CARD_HEADER}/>}/>
            <CardContent>
              <FormGroup>
                <FormControlLabel
                  control={<Switch checked={isVisibleDonor} value={'isVisibleDonor'} color='primary' onChange={this.handleClickSwitch('isVisibleDonor')}/>}
                  label={<Word wid={WID.DONATION_SETTINGS_CARD.VISIBLE_DONOR}/>}
                />
              </FormGroup>
            </CardContent>
          </Card>
        </Fade>
      </React.Fragment>
    )
  }
}

export default withStyles(styles, { withTheme: true })(DonationSettingsCard)


// WEBPACK FOOTER //
// ./src/Pages/Settings/components/DonationSettingsCard.js